/**
 * Error Utilities
 * Helper functions for error handling and structured error creation
 */

import { ApiError } from '../types';

/**
 * Create structured error from API error
 */
export function createStructuredError(error: unknown, context: string): ApiError {
  const e = error as Record<string, unknown>;
  const structuredError: ApiError = new Error(
    (e.message as string) || (e.error as string) || `${context} failed`
  );

  structuredError.code = (e.code as string) || (e.error_code as string) || 'UNKNOWN_ERROR';
  structuredError.statusCode = e.statusCode as number;
  structuredError.details = e.details || error;
  structuredError.recoverySuggestions = (e.recoverySuggestions as string[]) || (e.recovery_suggestions as string[]) || [
    'Check your internet connection',
    'Verify that the backend server is running',
    'Try again in a few moments'
  ];

  return structuredError;
}
